import {
  BehaviorSubject,
  delay,
  first,
  MonoTypeOperatorFunction,
  of,
  pipe,
  shareReplay,
  tap,
} from "rxjs";

// Placeholder value to emit exactly one value from the Observable
// this value is not needed for anything
const REQUIRED_PLACEHOLDER_VALUE = null;

export abstract class BaseStaticDataFormService {
  private _hasPendingRequests$ = new BehaviorSubject(false);

  public hasPendingRequests$ = this._hasPendingRequests$.asObservable();

  protected createDefaultHttpObservable() {
    return of(REQUIRED_PLACEHOLDER_VALUE).pipe(
      /**
       * The default value from the {@link _hasPendingRequests} is 'false' (synchronously). If now someone subscribes
       * to this Observable it will (immediately / synchronously / as part of the same event cycle) emit 'true' and we would then
       * run into the infamous ExpressionChangedAfterItHasBeenCheckedError.
       * The delay ensures that ALL the services inheriting from 'HttpBaseService', will
       * emit their 'true' value (in case of being subscribed to immediately) for being busy in the next event cycle.
       */
      delay(1),
      tap(() => {
        this.setHasPendingRequests();
      }),
    );
  }

  protected setHasPendingRequests() {
    this._hasPendingRequests$.next(true);
  }

  protected setHasNoPendingRequests() {
    this._hasPendingRequests$.next(false);
  }

  protected createShareReplayObservable<T>(): MonoTypeOperatorFunction<T> {
    return pipe(
      // Assumption: We are not dealing with streams and only expect a single response
      first(),
      tap({
        error: () => {
          this.setHasNoPendingRequests();
        },
        complete: () => {
          this.setHasNoPendingRequests();
        },
      }),
      shareReplay(1),
    );
  }
}
